import React from 'react';

const CalendarSkeleton = ({ sidebarOpen }) => {
  return (
    <>
      <main className="p-6 lg:p-10 flex flex-col h-screen overflow-hidden gap-6">
        {/* Page Title Skeleton */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 flex-shrink-0">
          <div className="flex items-center gap-4">
            {!sidebarOpen && (
              <div
                style={{
                  height: '40px',
                  width: '40px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '8px',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
            )}
            <div>
              <div
                style={{
                  height: '32px',
                  width: '180px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  marginBottom: '8px',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
              <div
                style={{
                  height: '20px',
                  width: '280px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
            </div>
          </div>

          <div className="flex items-center gap-4">
            <div
              style={{
                height: '56px',
                width: '120px',
                backgroundColor: '#e5e7eb',
                borderRadius: '12px',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
              }}
            />
            <div
              style={{
                height: '56px',
                width: '140px',
                backgroundColor: '#e5e7eb',
                borderRadius: '12px',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
              }}
            />
          </div>
        </div>

        {/* Calendar Card Skeleton */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            backgroundColor: 'white',
            borderRadius: '1rem',
            boxShadow:
              '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
            overflow: 'hidden'
          }}>
          <div style={{ padding: '2.5rem 1.5rem' }}>
            {/* Title and Controls Row */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1.5rem'
              }}>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div
                  style={{
                    height: '56px',
                    width: '56px',
                    backgroundColor: '#e5e7eb',
                    borderRadius: '12px',
                    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                  }}
                />
                <div
                  style={{
                    height: '32px',
                    width: '200px',
                    backgroundColor: '#e5e7eb',
                    borderRadius: '4px',
                    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                  }}
                />
              </div>
              <div
                style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
                {Array.from({ length: 2 }).map((_, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px'
                    }}>
                    <div
                      style={{
                        height: '20px',
                        width: '20px',
                        backgroundColor: '#e5e7eb',
                        borderRadius: '4px',
                        animation:
                          'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                      }}
                    />
                    <div
                      style={{
                        height: '20px',
                        width: '16px',
                        backgroundColor: '#e5e7eb',
                        borderRadius: '4px',
                        animation:
                          'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                      }}
                    />
                    <div
                      style={{
                        height: '20px',
                        width: '20px',
                        backgroundColor: '#e5e7eb',
                        borderRadius: '4px',
                        animation:
                          'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                      }}
                    />
                  </div>
                ))}
                <div
                  style={{
                    height: '40px',
                    width: '280px',
                    backgroundColor: '#e5e7eb',
                    borderRadius: '12px',
                    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                  }}
                />
              </div>
            </div>

            {/* Navigation Row */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1.5rem',
                paddingBottom: '1.5rem',
                borderBottom: '1px solid #e5e7eb'
              }}>
              <div style={{ display: 'flex', gap: '1rem' }}>
                {Array.from({ length: 3 }).map((_, idx) => (
                  <div
                    key={idx}
                    style={{
                      height: '44px',
                      width: idx === 2 ? '80px' : '44px',
                      backgroundColor: '#e5e7eb',
                      borderRadius: '8px',
                      animation:
                        'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                    }}
                  />
                ))}
              </div>
              <div
                style={{
                  height: '32px',
                  width: '180px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
              <div style={{ display: 'flex', gap: '1rem' }}>
                <div
                  style={{
                    height: '44px',
                    width: '140px',
                    backgroundColor: '#e5e7eb',
                    borderRadius: '8px',
                    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                  }}
                />
                <div
                  style={{
                    height: '48px',
                    width: '180px',
                    backgroundColor: '#e5e7eb',
                    borderRadius: '12px',
                    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                  }}
                />
              </div>
            </div>

            {/* Calendar Grid */}
            <div style={{ flex: 1, minHeight: 0, padding: '1.5rem' }}>
              {/* Week days header */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(7, 1fr)',
                  gap: '1px',
                  marginBottom: '0.5rem'
                }}>
                {[
                  'Sunday',
                  'Monday',
                  'Tuesday',
                  'Wednesday',
                  'Thursday',
                  'Friday',
                  'Saturday'
                ].map((day) => (
                  <div
                    key={day}
                    style={{
                      textAlign: 'center',
                      padding: '0.5rem',
                      fontWeight: '600',
                      fontSize: '14px',
                      color: '#6b7280'
                    }}>
                    {day}
                  </div>
                ))}
              </div>

              {/* Calendar days grid */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(7, 1fr)',
                  gap: '1px',
                  backgroundColor: '#e5e7eb',
                  border: '1px solid #e5e7eb',
                  borderRadius: '6px',
                  overflow: 'hidden'
                }}>
                {Array.from({ length: 35 }).map((_, idx) => (
                  <div
                    key={idx}
                    style={{
                      backgroundColor: 'white',
                      minHeight: '120px',
                      padding: '8px',
                      position: 'relative'
                    }}>
                    <div
                      style={{
                        height: '20px',
                        width: '24px',
                        backgroundColor: '#e5e7eb',
                        borderRadius: '4px',
                        animation:
                          'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
                        marginBottom: '8px'
                      }}
                    />
                    {/* Random event skeletons - solo grises */}
                    {idx % 7 === 2 && (
                      <div
                        style={{
                          height: '24px',
                          backgroundColor: '#e5e7eb',
                          borderRadius: '4px',
                          marginTop: '4px',
                          animation:
                            'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                        }}
                      />
                    )}
                    {idx % 9 === 0 && (
                      <>
                        <div
                          style={{
                            height: '24px',
                            backgroundColor: '#e5e7eb',
                            borderRadius: '4px',
                            marginTop: '4px',
                            animation:
                              'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                          }}
                        />
                        <div
                          style={{
                            height: '24px',
                            backgroundColor: '#e5e7eb',
                            borderRadius: '4px',
                            marginTop: '4px',
                            animation:
                              'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                          }}
                        />
                      </>
                    )}
                    {idx % 11 === 0 && (
                      <div
                        style={{
                          height: '24px',
                          backgroundColor: '#e5e7eb',
                          borderRadius: '4px',
                          marginTop: '4px',
                          animation:
                            'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                        }}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      <style>{`
      @keyframes pulse {
        0%, 100% {
          opacity: 1;
        }
        50% {
          opacity: 0.5;
        }
      }
    `}</style>
    </>
  );
};

export default CalendarSkeleton;
